import { LoginModalComponent } from '$core/modal/login-modal/login-modal.component';
import { AuthenticationService } from '$core/services/auth.service';
import { EyeSightService } from '$core/services/eye-sight.service';
import { LanguageService } from '$core/services/language.service';
import { SessionService } from '$core/services/session.service';
import { Overlays, OverlayService } from '$core/shell/overlay/overlay.service';
import { Component, OnInit } from '@angular/core';

import {
  faBars,
  faChevronDown,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { NotificationsDataService } from '$modules/personal/notifications/notifications-data.service';

@Component({
  selector: 'app-header-panel',
  templateUrl: './header-panel.component.html',
  styleUrls: ['./header-panel.component.scss'],
})
export class HeaderPanelComponent implements OnInit {
  public readonly faSearch = faSearch;
  public readonly faBars = faBars;
  public readonly faChevronDown = faChevronDown;
  public isOpenContactsInfo = false;
  public notificationsCounter$: Observable<number>;

  public get session() {
    return this.sessionService.session;
  }

  public get lang() {
    return this.languageService.currentLang;
  }

  constructor(
    private sessionService: SessionService,
    private overlayService: OverlayService,
    private modalService: BsModalService,
    private authService: AuthenticationService,
    private languageService: LanguageService,
    public eyeService: EyeSightService,
    private notificationsDataService: NotificationsDataService
  ) {}

  public ngOnInit(): void {
    this.notificationsCounter$ =
      this.notificationsDataService.notificationsCounter$;
  }

  public toggleMenu() {
    this.overlayService.toggle(Overlays.Menu);
  }

  public toggleSearch() {
    this.overlayService.toggle(Overlays.Search);
  }

  public openLogin() {
    this.modalService.show(LoginModalComponent, {
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered',
    });
  }

  public logout() {
    this.authService.logout(true);
  }

  public get isMenuOpen() {
    return this.overlayService.isOpen === Overlays.Menu;
  }

  public get isSearchOpen() {
    return this.overlayService.isOpen === Overlays.Search;
  }
}
